module.exports = __webpack_public_path__ + "img/zpravy.a1f2871c.svg";